import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSite } from '../../hooks/useSiteConfig';
import DynamicPage from '../../pages/DynamicPage';
import { CmsAuditToggle } from './CmsAuditToggle';

// Progressive migration: renders the builder version of a built-in page once the admin enables it; otherwise the coded page.
// `?cms=coded|builder|draft` forces a version for side-by-side audits (never changes what's live; `draft` needs an admin login).
// Admins also get a floating Coded / Live / Draft toggle (CmsAuditToggle) on these pages.
export const CmsSwitch = ({ path, children }) => {
  const { builderPaths, loaded } = useSite();
  const force = new URLSearchParams(useLocation().search).get('cms');
  let node = children;
  if (force === 'coded') node = children;
  else if (force === 'builder') node = <DynamicPage />;
  else if (force === 'draft') node = <DynamicPage draft />;
  else if (!loaded) node = <div className="min-h-screen" data-testid="cms-switch-pending" />;
  else if (builderPaths?.includes(path)) node = <DynamicPage />;
  return <>{node}<CmsAuditToggle path={path} /></>;
};
